import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class Course
 * @exports Service/Cms/Course
 * @description API Course Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Course {
	/**
	 * @static @name list
	 * @description Get all course as a list that can be manipulated through post body properties
	 * @returns {Object} Promise a http response
	 */
	static list(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			'cms/course/list',
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-course-${cacheHash}`
			}
		);
	}
}
